import Vue from 'vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// import echarts from 'echarts'

import App from './App'
import store from './store'
import router from './router'

// import './permission'

Vue.config.productionTip = false
// Vue.prototype.$echarts = echarts

Vue.use(ElementUI)
ElementUI.Dialog.props.closeOnClickModal.default = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js